/** @format */
import { CommonModule } from '@angular/common';
import { HomrTextLinkComponent } from './homr-text-link.component';
import { NgModule } from '@angular/core';

/**
 * HomrTextLink Module
 */
@NgModule({
	declarations: [HomrTextLinkComponent],
	imports: [CommonModule],
	exports: [HomrTextLinkComponent]
})
export class HomrTextLinkModule {}
